core.constant('loginMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION": {
          "REMIND_PASSWORD": "Przypomnij hasło"
        },
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
          "MODULE_LOGIN": "Moduł logowania"
        },
        "LOGIN": {
          "TITLE": "Logowanie",
          "USERNAME": "Identyfikator",
          "PASSWORD": "Hasło",
          "LOGIN": "Login",
          "LOGIN_ACTION": "Zaloguj",
          "REGISTER": "Załóż konto w Meedy Doctors",
          "REGISTER_ALAB": "Załóż konto w ALAB Meedy Doctors",
          "TEST_MEEDY_DOCTORS" : "Wypróbuj Meedy Doctors",
          "ACCEPT_RULES" : "Akceptuję regulamin usługi",
          "EMAIL" : "Email",
          "DEMO_KNOWLEDGE" : "Mam świadomość, że wersja demonstracyjna służy jedynie do zapoznania się z funkcjonalnościami systemu Meedy Doctors, a wszelkie wprowadzone przeze mnie dane zostaną automatycznie usunięte.",
          "IM_PHYSICIAN" : "Oświadczam, że jestem lekarzem/specjalistą medycznym.",
          "DEMO_DESCRIPTION" : "Z wersji demonstracyjnej systemu Meedy Doctors mogą korzystać wyłącznie lekarze oraz specjaliści z zakresu np. psychologii, fizjoterapii, dietetyki.",
          "DEMO_WAITING" : "Proszę czekać. Trwa generowanie przykładowych danych"
        },
        "LOGIN_CLINICS": {
          "TEST_MEEDY_DOCTORS" : "Wypróbuj Meedy Clinic",
          "DEMO_KNOWLEDGE" : "Mam świadomość, że wersja demonstracyjna służy jedynie do zapoznania się z funkcjonalnościami systemu Meedy Clinic, a wszelkie wprowadzone przeze mnie dane zostaną automatycznie usunięte.",
          "DEMO_DESCRIPTION" : "Z wersji demonstracyjnej systemu Meedy Clinic mogą korzystać wyłącznie lekarze oraz specjaliści z zakresu np. psychologii, fizjoterapii, dietetyki."
        },
        "REMIND_PASSWORD": {

        },
        "BROWSER_CHANGE": {
          "WELCOME_PARAGRAPH" : "Witaj w <b>Meedy Doctors</b>!",
          "DESCRIBE_PROBLEM_PARAGRAPH" : "Zauważyliśmy, że przyszedłeś do nas używając przeglądarki <b>Internet Explorer</b>. Jest to domyślna przeglądarka dla systemów operacyjnych starszych niż <b>Windows 10</b>. Niestety, twórcy Internet Explorera <b>zrezygnowali</b> z rozwijania jej i pozostawili wiele niedociągnięć, które mogą uprzykrzyć Ci korzystanie z <b>Meedy Doctors</b>.",
          "PROPOSITION_PARAGRAPH" : "Proponujemy skorzystanie z przeglądarek poniżej, gdzie ich twórcy wciąż dbają o jakość i zadowolenie swoich użytkowników. Kliknij poniższe logo, a przeniesiemy Cie do miejsca, z którego będziesz mógł(a) pobrać nową przeglądarkę."
        }
      }
    }
  }
});
